import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { literatureReviewPaths } from '@/paths';
import {
  useCreateLiteratureReviewService,
  useLiteratureReviewsService,
} from '@/services/literatureReviews';
import { BookOpen, Plus } from 'lucide-react';
import { type FC } from 'react';
import { useNavigate } from 'react-router';
import { EmptyState } from './components/EmptyState';
import { LiteratureReviewsTable } from './components/LiteratureReviewsTable';

export const LiteratureReviewsPage: FC = () => {
  const navigate = useNavigate();
  const { literatureReviews, isPending } = useLiteratureReviewsService();
  const { createLiteratureReview, isPending: isCreating } =
    useCreateLiteratureReviewService();

  const handleCreateReview = async () => {
    createLiteratureReview(
      {
        name: 'New Literature Review',
      },
      {
        onSuccess: data => {
          navigate(`${data.id}/${literatureReviewPaths.steps.search}`);
        },
      }
    );
  };

  const isEmpty = literatureReviews.length === 0;

  return (
    <FlexCol p="6" w="full" gap="6" className="max-w-[1600px]">
      <FlexRow alignItems="center" justifyContent="between" w="full">
        <PageHeader
          title="Literature review"
          subtitle="Systematic literature review workflow"
        >
          <BookOpen size={22} />
        </PageHeader>
        {!isEmpty && (
          <Button onClick={handleCreateReview} disabled={isCreating}>
            <Plus />
            Create Literature Review
          </Button>
        )}
      </FlexRow>

      {isEmpty && !isPending ? (
        <FlexCol
          alignItems="center"
          justifyContent="center"
          gap="4"
          className="flex-1 py-16"
        >
          <EmptyState onCreateReview={handleCreateReview} />
        </FlexCol>
      ) : (
        <LiteratureReviewsTable />
      )}
    </FlexCol>
  );
};
